/* ==========================================================================
   VEYRO — Theme scripts
   ========================================================================== */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, settings: {}, strings: {} };
  var routes = theme.routes || {};
  var strings = theme.strings || {};

  /* ---------- Utilities ---------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }
  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function storageGet(key) { try { return window.localStorage.getItem(key); } catch (e) { return null; } }
  function storageSet(key, val) { try { window.localStorage.setItem(key, val); } catch (e) { /* ignore */ } }
  function isDesktop() { return window.matchMedia('(min-width: 990px)').matches; }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || theme.moneyFormat || '${{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = withDelimiters(cents, 2, ' ', '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  var toastEl = qs('[data-toast]');
  var toastTimer;
  function toast(message) {
    if (!toastEl) return;
    toastEl.textContent = message;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2800);
  }

  /* ---------- Overlay manager (drawers, modals, search) ---------- */
  var openOverlays = [];
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function lockScroll() { document.body.classList.toggle('is-locked', openOverlays.length > 0); }

  function openOverlay(el, trigger) {
    if (!el || el.classList.contains('is-open')) return;
    el.hidden = false;
    el._trigger = trigger || document.activeElement;
    openOverlays.push(el);
    lockScroll();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { el.classList.add('is-open'); });
    });
    if (trigger && trigger.setAttribute) trigger.setAttribute('aria-expanded', 'true');
    setTimeout(function () {
      var focusTarget = qs('[data-autofocus], .search-modal__input', el) || qs(FOCUSABLE, qs('[role="dialog"]', el) || el);
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    }, 60);
    document.dispatchEvent(new CustomEvent('overlay:open', { detail: { el: el } }));
  }

  function closeOverlay(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    openOverlays = openOverlays.filter(function (o) { return o !== el; });
    lockScroll();
    if (el._trigger && el._trigger.setAttribute) el._trigger.setAttribute('aria-expanded', 'false');
    setTimeout(function () {
      if (!el.classList.contains('is-open')) el.hidden = true;
    }, 450);
    if (el._trigger && el._trigger.focus && document.contains(el._trigger)) el._trigger.focus({ preventScroll: true });
    document.dispatchEvent(new CustomEvent('overlay:close', { detail: { el: el } }));
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open], [data-modal-open]');
    if (opener) {
      e.preventDefault();
      var id = opener.getAttribute('data-drawer-open') || opener.getAttribute('data-modal-open');
      openOverlay(document.getElementById(id), opener);
      return;
    }
    var closer = e.target.closest('[data-drawer-close], [data-modal-close]');
    if (closer) {
      var parent = closer.closest('[data-drawer], [data-modal]');
      if (parent) {
        if (closer.type === 'submit') { closeOverlay(parent); return; }
        e.preventDefault();
        closeOverlay(parent);
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openOverlays.length) {
      closeOverlay(openOverlays[openOverlays.length - 1]);
      return;
    }
    if (e.key === 'Tab' && openOverlays.length) {
      var top = openOverlays[openOverlays.length - 1];
      var focusables = qsa(FOCUSABLE, top).filter(function (n) { return n.offsetParent !== null; });
      if (!focusables.length) return;
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Header ---------- */
  var header = qs('[data-header]');
  var headerWrap = header ? header.closest('.shopify-section') : null;
  if (header) {
    var isTransparent = header.getAttribute('data-header-style') === 'transparent';
    var isSticky = header.classList.contains('site-header--sticky');
    var lastY = window.scrollY;
    var setHeaderHeight = function () {
      var h = isSticky && headerWrap ? header.offsetHeight : 0;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    };
    var onScroll = function () {
      var y = window.scrollY;
      if (isTransparent) header.classList.toggle('is-solid', y > 10 || openOverlays.length > 0);
      if (isSticky) {
        var hide = y > 300 && y > lastY && !header.matches(':hover') && !openOverlays.length;
        header.classList.toggle('is-hidden', hide);
        document.documentElement.style.setProperty('--header-height', hide ? '0px' : header.offsetHeight + 'px');
      }
      lastY = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', debounce(setHeaderHeight, 150));
    setHeaderHeight();
    onScroll();
    document.addEventListener('overlay:open', onScroll);
    document.addEventListener('overlay:close', function () { setTimeout(onScroll, 50); });
  }

  /* ---------- Announcement bar ---------- */
  qsa('[data-announcement]').forEach(function (bar) {
    var slides = qsa('[data-announcement-slide]', bar);
    if (slides.length < 2) return;
    var i = 0;
    var speed = parseInt(bar.getAttribute('data-speed'), 10) || 5000;
    var timer;
    function go(n) {
      slides[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
    }
    function start() { stop(); timer = setInterval(function () { go(i + 1); }, speed); }
    function stop() { clearInterval(timer); }
    var prev = qs('[data-announcement-prev]', bar), next = qs('[data-announcement-next]', bar);
    if (prev) prev.addEventListener('click', function () { go(i - 1); start(); });
    if (next) next.addEventListener('click', function () { go(i + 1); start(); });
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    start();
  });

  /* ---------- Hero slideshow ---------- */
  qsa('[data-hero]').forEach(function (hero) {
    var slides = qsa('[data-hero-slide]', hero);
    var dots = qsa('[data-hero-dot]', hero);
    if (slides.length < 2) return;
    var speed = parseInt(hero.getAttribute('data-speed'), 10) || 6000;
    var autoplay = hero.getAttribute('data-autoplay') === 'true';
    var i = 0, timer = null, paused = !autoplay;
    hero.style.setProperty('--hero-speed', speed + 'ms');
    if (paused) hero.classList.add('is-paused');

    function go(n) {
      slides[i].classList.remove('is-active');
      slides[i].setAttribute('aria-hidden', 'true');
      if (dots[i]) dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      slides[i].removeAttribute('aria-hidden');
      if (dots[i]) {
        // restart progress animation
        void dots[i].offsetWidth;
        dots[i].classList.add('is-active');
      }
      var vid = qs('video', slides[i]);
      if (vid) { try { vid.play(); } catch (e) { /* ignore */ } }
    }
    function start() { clearInterval(timer); if (!paused) timer = setInterval(function () { go(i + 1); }, speed); }

    dots.forEach(function (dot, idx) {
      dot.addEventListener('click', function () { go(idx); start(); });
    });
    var pauseBtn = qs('[data-hero-pause]', hero);
    if (pauseBtn) pauseBtn.addEventListener('click', function () {
      paused = !paused;
      hero.classList.toggle('is-paused', paused);
      pauseBtn.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
      start();
    });

    // swipe
    var x0 = null;
    hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 50) { go(dx < 0 ? i + 1 : i - 1); start(); }
      x0 = null;
    });
    start();
  });

  /* ---------- Reveal on scroll ---------- */
  function initReveal(ctx) {
    var els = qsa('[data-reveal]:not(.is-revealed)', ctx);
    if (!document.body.classList.contains('animations-enabled') || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }
  initReveal();

  /* ==========================================================================
     Search
     ========================================================================== */
  var searchModal = qs('[data-search-modal]');
  if (searchModal) {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-open]')) {
        e.preventDefault();
        openOverlay(searchModal, e.target.closest('[data-search-open]'));
      } else if (e.target.closest('[data-search-close]')) {
        e.preventDefault();
        closeOverlay(searchModal);
      }
    });

    var input = qs('[data-predictive-input]', searchModal);
    var results = qs('[data-predictive-results]', searchModal);
    var controller = null;
    if (input && results && routes.predictiveSearch) {
      var runSearch = debounce(function () {
        var term = input.value.trim();
        if (!term) {
          results.innerHTML = '';
          searchModal.classList.remove('has-results');
          return;
        }
        if (controller) controller.abort();
        controller = 'AbortController' in window ? new AbortController() : null;
        var url = routes.predictiveSearch + '?q=' + encodeURIComponent(term) +
          '&section_id=predictive-search' +
          '&resources[type]=product,collection,query,page&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,vendor';
        fetch(url, controller ? { signal: controller.signal } : {})
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = parseHTML(html);
            var content = qs('[data-predictive-content]', doc);
            results.innerHTML = content ? content.outerHTML : '';
            searchModal.classList.toggle('has-results', !!content);
          })
          .catch(function () { /* aborted */ });
      }, 260);
      input.addEventListener('input', runSearch);
    }
  }

  /* ==========================================================================
     Cart
     ========================================================================== */
  var cartDrawer = qs('[data-cart-drawer]');

  function getSectionsToRender() {
    var ids = ['cart-drawer-body'];
    qsa('[data-main-cart]').forEach(function (el) {
      var id = el.getAttribute('data-section-id');
      if (id) ids.push(id);
    });
    return ids;
  }

  function renderCartSections(sections) {
    if (!sections) return;
    var count = null;
    var drawerHTML = sections['cart-drawer-body'];
    if (drawerHTML) {
      var doc = parseHTML(drawerHTML);
      var fresh = qs('[data-cart-drawer-inner]', doc);
      if (fresh) {
        count = parseInt(fresh.getAttribute('data-item-count'), 10);
        var current = qs('[data-cart-drawer-inner]');
        if (current) current.replaceWith(fresh);
      }
    }
    qsa('[data-main-cart]').forEach(function (el) {
      var id = el.getAttribute('data-section-id');
      if (!sections[id]) return;
      var doc2 = parseHTML(sections[id]);
      var freshMain = qs('[data-main-cart]', doc2);
      if (freshMain) el.innerHTML = freshMain.innerHTML;
    });
    if (count !== null && !isNaN(count)) updateCartCount(count);
    loadCartRecommendations();
  }

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
      var link = el.closest('[data-cart-open]');
      if (link) link.setAttribute('aria-label', 'Bag, ' + count + ' items');
    });
  }

  function openCart() {
    if (cartDrawer && theme.settings.cartType === 'drawer') {
      qsa('[data-modal].is-open').forEach(closeOverlay);
      openOverlay(cartDrawer);
      loadCartRecommendations();
    } else {
      window.location.href = routes.cart || '/cart';
    }
  }

  function addToCart(formData) {
    formData.append('sections', getSectionsToRender().join(','));
    formData.append('sections_url', window.location.pathname);
    return fetch((routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) {
          var err = new Error(data.description || data.message || 'Could not add to bag');
          throw err;
        }
        return data;
      });
    }).then(function (data) {
      renderCartSections(data.sections);
      document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
      return data;
    });
  }

  function changeLine(line, quantity, lineEl) {
    if (lineEl) lineEl.classList.add('is-updating');
    return fetch((routes.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: getSectionsToRender(), sections_url: window.location.pathname })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) throw new Error(data.description || data.message || 'Could not update bag');
        return data;
      });
    }).then(function (cart) {
      renderCartSections(cart.sections);
      return cart;
    }).catch(function (err) {
      if (lineEl) lineEl.classList.remove('is-updating');
      toast(err.message);
    });
  }

  // Open drawer from header bag icon
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-cart-open]');
    if (trigger && cartDrawer && theme.settings.cartType === 'drawer') {
      e.preventDefault();
      openCart();
    }
  });

  // Line quantity / remove (drawer + cart page)
  document.addEventListener('click', function (e) {
    var line = e.target.closest('[data-cart-line]');
    if (!line) return;
    var index = parseInt(line.getAttribute('data-line'), 10);
    var inputEl = qs('[data-line-qty-input]', line);
    var qty = inputEl ? parseInt(inputEl.value, 10) || 0 : 1;
    var changeBtn = e.target.closest('[data-line-qty-change]');
    if (changeBtn) {
      e.preventDefault();
      var delta = parseInt(changeBtn.getAttribute('data-line-qty-change'), 10);
      changeLine(index, Math.max(0, qty + delta), line);
    } else if (e.target.closest('[data-line-remove]')) {
      e.preventDefault();
      changeLine(index, 0, line);
    }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty-input]');
    if (!input) return;
    var line = input.closest('[data-cart-line]');
    changeLine(parseInt(line.getAttribute('data-line'), 10), Math.max(0, parseInt(input.value, 10) || 0), line);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('[data-line-qty-input]')) {
      e.preventDefault();
      e.target.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  // Cart note
  var saveNote = debounce(function (value) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ note: value })
    });
  }, 500);
  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-cart-note]')) saveNote(e.target.value);
  });

  // Cart drawer recommendations
  var recsCache = {};
  function loadCartRecommendations() {
    var wrap = qs('[data-cart-recommendations]');
    if (!wrap || !routes.recommendations) return;
    var productId = wrap.getAttribute('data-product-id');
    var list = qs('[data-cart-recommendations-list]', wrap);
    if (!productId || !list) return;

    function render(products) {
      var inCart = qsa('[data-cart-line] .cart-line__title').map(function (a) { return a.textContent.trim(); });
      var items = products.filter(function (p) { return p.available && inCart.indexOf(p.title) === -1; }).slice(0, 3);
      if (!items.length) { wrap.hidden = true; return; }
      list.innerHTML = items.map(function (p) {
        var variant = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
        var multi = p.variants.length > 1;
        return '<div class="cart-rec">' +
          '<a href="' + p.url + '" class="cart-rec__media">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div><a href="' + p.url + '" class="cart-rec__title">' + p.title + '</a><span class="cart-rec__price">' + formatMoney(p.price) + '</span></div>' +
          (multi
            ? '<button type="button" class="cart-rec__add" data-quick-add="' + p.url + '">Select</button>'
            : '<button type="button" class="cart-rec__add" data-rec-add="' + variant.id + '">Add</button>') +
          '</div>';
      }).join('');
      wrap.hidden = false;
    }

    if (recsCache[productId]) { render(recsCache[productId]); return; }
    fetch(routes.recommendations + '.json?product_id=' + productId + '&limit=6&intent=complementary')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.products && data.products.length) return data;
        return fetch(routes.recommendations + '.json?product_id=' + productId + '&limit=6').then(function (r) { return r.json(); });
      })
      .then(function (data) {
        recsCache[productId] = data.products || [];
        render(recsCache[productId]);
      })
      .catch(function () { wrap.hidden = true; });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rec-add]');
    if (!btn) return;
    e.preventDefault();
    var fd = new FormData();
    fd.append('id', btn.getAttribute('data-rec-add'));
    fd.append('quantity', 1);
    btn.textContent = '…';
    addToCart(fd).catch(function (err) { toast(err.message); });
  });

  /* ==========================================================================
     Product
     ========================================================================== */
  function initProduct(root) {
    if (!root || root._initialized) return;
    root._initialized = true;

    var jsonEl = qs('[data-product-json]', root);
    var product = null;
    try { product = jsonEl ? JSON.parse(jsonEl.textContent) : null; } catch (e) { product = null; }
    var inventory = {};
    try { var invEl = qs('[data-inventory-json]', root); inventory = invEl ? JSON.parse(invEl.textContent) : {}; } catch (e) { inventory = {}; }
    var updateUrl = root.getAttribute('data-update-url') === 'true';

    var gallery = qs('[data-gallery]', root) || root;
    var track = qs('[data-gallery-track]', root);

    /* --- Variant selection --- */
    function getSelectedOptions() {
      return qsa('[data-option-index]', root).sort(function (a, b) {
        return a.getAttribute('data-option-index') - b.getAttribute('data-option-index');
      }).map(function (fs) {
        var checked = qs('[data-option-input]:checked', fs);
        return checked ? checked.value : null;
      });
    }

    function findVariant(options) {
      if (!product) return null;
      return product.variants.filter(function (v) {
        return options.every(function (val, i) { return v.options[i] === val; });
      })[0] || null;
    }

    function updateAvailability(selected) {
      if (!product) return;
      qsa('[data-option-index]', root).forEach(function (fs) {
        var idx = parseInt(fs.getAttribute('data-option-index'), 10);
        qsa('[data-option-input]', fs).forEach(function (input) {
          // A value is available if some in-stock variant has it, combined with the choices made in earlier options
          var available = product.variants.some(function (v) {
            if (!v.available || v.options[idx] !== input.value) return false;
            for (var i = 0; i < idx; i++) { if (v.options[i] !== selected[i]) return false; }
            return true;
          });
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !available);
        });
      });
    }

    function priceHTML(variant) {
      var html = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        html += '<span class="visually-hidden">Sale price</span><span class="price price--sale">' + formatMoney(variant.price) + '</span>';
        html += '<span class="visually-hidden">Regular price</span><s class="price price--compare">' + formatMoney(variant.compare_at_price) + '</s>';
        html += '<span class="badge badge--sale">-' + pct + '%</span>';
      } else {
        html += '<span class="price">' + formatMoney(variant.price) + '</span>';
      }
      if (variant.unit_price_measurement && variant.unit_price) {
        var m = variant.unit_price_measurement;
        html += '<span class="price__unit">' + formatMoney(variant.unit_price) + '/' + (m.reference_value !== 1 ? m.reference_value : '') + m.reference_unit + '</span>';
      }
      return html;
    }

    function setButtons(state) {
      qsa('[data-add-button]', root).forEach(function (btn) {
        var label = qs('[data-add-label]', btn);
        btn.disabled = state !== 'available';
        if (label) label.textContent = state === 'available' ? strings.addToCart : (state === 'soldout' ? strings.soldOut : strings.unavailable);
      });
      // sticky bar lives outside the product root on product pages
      var section = root.closest('.shopify-section') || document;
      qsa('.sticky-atc [data-add-button]', section).forEach(function (btn) {
        var label = qs('[data-add-label]', btn);
        btn.disabled = state !== 'available';
        if (label) label.textContent = state === 'available' ? strings.addToCart : (state === 'soldout' ? strings.soldOut : strings.unavailable);
      });
    }

    function goToMedia(mediaId) {
      if (!track || !mediaId) return;
      var item = qs('[data-media-id="' + mediaId + '"]', track);
      if (!item) return;
      var layoutGrid = gallery.classList && (gallery.classList.contains('product-gallery--grid') || gallery.classList.contains('product-gallery--stacked'));
      if (isDesktop() && layoutGrid) {
        track.insertBefore(item, track.firstElementChild);
        reindexGallery();
      } else {
        track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
    }

    function onVariantChange() {
      var selected = getSelectedOptions();
      var variant = findVariant(selected);

      qsa('[data-option-index]', root).forEach(function (fs, i) {
        var label = qs('[data-selected-value]', fs);
        if (label) label.textContent = selected[i] || '';
      });
      updateAvailability(selected);

      if (!variant) { setButtons('unavailable'); return; }

      qsa('form input[name="id"]', root).forEach(function (input) { input.value = variant.id; });
      setButtons(variant.available ? 'available' : 'soldout');

      var priceEl = qs('[data-product-price] [data-price-block]', root);
      if (priceEl) priceEl.innerHTML = priceHTML(variant);
      var section = root.closest('.shopify-section') || document;
      var stickyPrice = qs('[data-sticky-price] [data-price-block]', section);
      if (stickyPrice) stickyPrice.innerHTML = priceHTML(variant).replace(/<span class="badge[^<]*<\/span>/, '');
      var stickyVariant = qs('[data-sticky-variant]', section);
      if (stickyVariant) stickyVariant.textContent = variant.title;

      var inv = qs('[data-inventory]', root);
      if (inv) {
        var threshold = parseInt(inv.getAttribute('data-threshold'), 10) || 5;
        var data = inventory[variant.id] || {};
        var text = qs('[data-inventory-text]', inv);
        inv.classList.remove('is-low', 'is-out');
        if (!variant.available) { inv.classList.add('is-out'); text.textContent = 'Out of stock'; }
        else if (data.managed && data.qty > 0 && data.qty <= threshold) { inv.classList.add('is-low'); text.textContent = 'Only ' + data.qty + ' left'; }
        else { text.textContent = 'In stock, ready to ship'; }
      }

      if (variant.featured_media) goToMedia(variant.featured_media.id);

      if (updateUrl && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({ path: url.toString() }, '', url.toString());
      }
      root.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: variant } }));
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-input]')) onVariantChange();
    });
    if (product) updateAvailability(getSelectedOptions());

    /* --- Quantity --- */
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      var input = qs('.qty__input', btn.parentNode);
      var val = (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-qty-change'), 10);
      input.value = Math.max(1, val);
    });

    /* --- Gallery --- */
    function reindexGallery() {
      qsa('[data-gallery-item]', track).forEach(function (item, idx) { item.setAttribute('data-index', idx); });
    }
    if (track) {
      var counter = qs('[data-gallery-current]', root);
      var dotsEls = qsa('[data-gallery-dot]', root);
      var thumbs = qsa('[data-gallery-thumb]', root);
      var onTrackScroll = debounce(function () {
        var idx = Math.round(track.scrollLeft / (track.clientWidth || 1));
        if (counter) counter.textContent = idx + 1;
        dotsEls.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      }, 60);
      track.addEventListener('scroll', onTrackScroll, { passive: true });
      var thumbsWrap = qs('[data-gallery-thumbs]', root);
      var prevBtn = qs('[data-gallery-prev]', root);
      var nextBtn = qs('[data-gallery-next]', root);
      var currentIndex = function () { return Math.round(track.scrollLeft / (track.clientWidth || 1)); };
      var goToIndex = function (idx) {
        var items = qsa('[data-gallery-item]', track);
        if (!items.length) return;
        idx = (idx + items.length) % items.length; // loop around
        track.scrollTo({ left: items[idx].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      };
      var syncUI = function () {
        var idx = currentIndex();
        if (thumbsWrap && thumbs[idx]) {
          var t = thumbs[idx].parentNode;
          var left = t.offsetLeft - thumbsWrap.offsetLeft - (thumbsWrap.clientWidth - t.offsetWidth) / 2;
          thumbsWrap.scrollTo({ left: left, behavior: 'smooth' });
        }
      };
      track.addEventListener('scroll', debounce(syncUI, 80), { passive: true });
      if (prevBtn) prevBtn.addEventListener('click', function () { goToIndex(currentIndex() - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goToIndex(currentIndex() + 1); });
      gallery.addEventListener('keydown', function (e) {
        if (e.target.closest('input, textarea, select')) return;
        if (e.key === 'ArrowLeft') { e.preventDefault(); goToIndex(currentIndex() - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goToIndex(currentIndex() + 1); }
      });
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          goToIndex(parseInt(thumb.getAttribute('data-gallery-thumb'), 10));
        });
      });
    }

    var zoomModal = qs('[data-zoom-modal]', root.closest('.shopify-section') || root);
    if (zoomModal) {
      root.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-zoom-open]');
        if (!btn) return;
        var original = btn.getAttribute('data-zoom-open');
        openOverlay(zoomModal, btn);
        var target = qs('[data-zoom-item="' + original + '"]', zoomModal);
        setTimeout(function () { if (target) target.scrollIntoView({ block: 'start' }); }, 30);
      });
      zoomModal.addEventListener('click', function (e) {
        if (e.target.closest('[data-zoom-close]') || e.target.closest('.zoom-modal__item')) closeOverlay(zoomModal);
      });
      zoomModal.setAttribute('data-modal', '');
    }

    /* --- Sticky add to cart --- */
    var section = root.closest('.shopify-section') || document;
    var sticky = qs('[data-sticky-atc]', section);
    var mainBtn = qs('.product__buy [data-add-button]', root);
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      var footer = qs('.site-footer');
      var ioSticky = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', past);
          sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
        });
      });
      ioSticky.observe(mainBtn);
      if (footer) {
        new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) sticky.classList.remove('is-visible');
        }).observe(footer);
      }
    }

    /* --- Share --- */
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-share]');
      if (!btn) return;
      var url = btn.getAttribute('data-share-url');
      if (navigator.share) {
        navigator.share({ title: btn.getAttribute('data-share-title'), url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () { toast('Link copied'); });
      }
    });
  }

  qsa('[data-product-root]').forEach(initProduct);

  /* --- Add to cart forms (product page, quick add, cards) --- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var submitter = e.submitter && e.submitter.matches('[data-add-button]') ? e.submitter : qs('[data-add-button]', form);
    var errorEl = qs('[data-form-error]', form);
    if (errorEl) errorEl.hidden = true;
    if (submitter) { submitter.classList.add('is-loading'); submitter.setAttribute('aria-busy', 'true'); }

    addToCart(new FormData(form))
      .then(function () {
        var quickModal = form.closest('[data-quick-add-modal]');
        if (quickModal) closeOverlay(quickModal);
        if (cartDrawer && theme.settings.cartType === 'drawer') {
          setTimeout(openCart, quickModal ? 300 : 0);
        } else {
          window.location.href = routes.cart || '/cart';
        }
      })
      .catch(function (err) {
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        else toast(err.message);
      })
      .finally(function () {
        if (submitter) { submitter.classList.remove('is-loading'); submitter.removeAttribute('aria-busy'); }
      });
  });

  /* --- Quick add modal --- */
  var quickModal = qs('[data-quick-add-modal]');
  var quickContent = qs('[data-quick-add-content]');
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn || !quickModal) return;
    e.preventDefault();
    var url = btn.getAttribute('data-quick-add');
    quickContent.innerHTML = '<div class="quick-add__loading"></div>';
    if (cartDrawer && cartDrawer.classList.contains('is-open')) closeOverlay(cartDrawer);
    openOverlay(quickModal, btn);
    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=quick-add')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = parseHTML(html);
        var root = qs('[data-product-root]', doc);
        if (!root) throw new Error('Unable to load product');
        quickContent.innerHTML = '';
        quickContent.appendChild(document.adoptNode(root));
        initProduct(qs('[data-product-root]', quickContent));
        if (window.Shopify && window.Shopify.PaymentButton) window.Shopify.PaymentButton.init();
      })
      .catch(function () {
        quickContent.innerHTML = '<p class="text-center" style="padding:60px 0">Unable to load product. <a class="link-underline" href="' + url + '">View product</a></p>';
      });
  });

  /* --- Product card: swatch hover swaps image --- */
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest('[data-swatch-image]');
    if (!sw) return;
    var card = sw.closest('[data-product-card]');
    var img = card && qs('.product-card__img--primary', card);
    if (!img) return;
    if (!img._original) img._original = { src: img.src, srcset: img.srcset };
    img.srcset = '';
    img.src = sw.getAttribute('data-swatch-image');
    card._swatchActive = true;
  });
  document.addEventListener('mouseout', function (e) {
    var card = e.target.closest('[data-product-card]');
    if (!card || !card._swatchActive) return;
    if (e.relatedTarget && card.contains(e.relatedTarget)) return;
    var img = qs('.product-card__img--primary', card);
    if (img && img._original) { img.src = img._original.src; img.srcset = img._original.srcset; }
    card._swatchActive = false;
  });

  /* ==========================================================================
     Product recommendations sections
     ========================================================================== */
  qsa('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    var load = function () {
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = parseHTML(html);
        var fresh = qs('[data-recommendations]', doc);
        if (fresh && fresh.innerHTML.trim().length) {
          el.innerHTML = fresh.innerHTML;
          initReveal(el);
        } else {
          el.hidden = true;
        }
      }).catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); load(); }
      }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(el);
    } else { load(); }
  });

  /* ==========================================================================
     Collection / search filtering
     ========================================================================== */
  function getFacetSection(el) { return el.closest('[data-facets-section]'); }

  function applyGridPreference(ctx) {
    var pref = storageGet('veyro-grid-cols');
    qsa('[data-product-grid]', ctx).forEach(function (grid) {
      if (pref === '2') grid.setAttribute('data-cols', '2');
    });
    qsa('[data-grid-cols]', ctx).forEach(function (btn) {
      var active = pref ? btn.getAttribute('data-grid-cols') === pref : btn.getAttribute('data-grid-cols') === '4';
      btn.classList.toggle('is-active', active);
    });
  }

  function renderFacetSection(sectionEl, url, push) {
    var id = sectionEl.getAttribute('data-section-id');
    var wrapper = sectionEl.closest('.shopify-section') || sectionEl.parentNode;
    sectionEl.classList.add('is-loading');
    var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + id;
    return fetch(fetchUrl).then(function (r) { return r.text(); }).then(function (html) {
      var doc = parseHTML(html);
      var fresh = qs('[data-facets-section]', doc);
      if (!fresh) { window.location.href = url; return; }
      // close any open drawer belonging to this section
      qsa('[data-drawer].is-open', sectionEl).forEach(closeOverlay);
      openOverlays = openOverlays.filter(function (o) { return document.contains(o) && !sectionEl.contains(o); });
      lockScroll();
      sectionEl.replaceWith(fresh);
      applyGridPreference(fresh);
      initReveal(fresh);
      if (push !== false) window.history.pushState({ facetUrl: url }, '', url);
      var top = fresh.getBoundingClientRect().top + window.scrollY - 40;
      if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
    }).catch(function () { window.location.href = url; });
  }

  function formToUrl(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (value !== '') params.append(key, value);
    });
    var action = form.getAttribute('action') || window.location.pathname;
    var qsStr = params.toString();
    return action + (qsStr ? '?' + qsStr : '');
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-facets-form]');
    if (!form) return;
    var sectionEl = getFacetSection(form);
    if (!sectionEl) return;
    e.preventDefault();
    renderFacetSection(sectionEl, formToUrl(form));
  });
  document.addEventListener('change', function (e) {
    var sort = e.target.closest('[data-facet-sort]');
    if (!sort) return;
    var sectionEl = getFacetSection(sort);
    var form = sort.form || document.getElementById(sort.getAttribute('form'));
    if (sectionEl && form) renderFacetSection(sectionEl, formToUrl(form));
  });
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-facet-link]');
    if (!link) return;
    var sectionEl = getFacetSection(link);
    if (!sectionEl) return;
    e.preventDefault();
    renderFacetSection(sectionEl, link.getAttribute('href'));
  });
  window.addEventListener('popstate', function (e) {
    var sectionEl = qs('[data-facets-section]');
    if (sectionEl && e.state && e.state.facetUrl !== undefined) renderFacetSection(sectionEl, window.location.href, false);
  });
  if (qs('[data-facets-section]') && window.history.replaceState) {
    window.history.replaceState({ facetUrl: window.location.href }, '', window.location.href);
  }

  // Load more
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-load-more]');
    if (!btn) return;
    var sectionEl = getFacetSection(btn);
    if (!sectionEl) return;
    e.preventDefault();
    btn.classList.add('is-loading');
    var url = btn.getAttribute('href');
    var id = sectionEl.getAttribute('data-section-id');
    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + id)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = parseHTML(html);
        var grid = qs('[data-product-grid]', sectionEl);
        var newGrid = qs('[data-product-grid]', doc);
        if (grid && newGrid) {
          Array.prototype.slice.call(newGrid.children).forEach(function (child) { grid.appendChild(document.adoptNode(child)); });
        }
        var wrap = qs('[data-load-more-wrap]', sectionEl);
        var newWrap = qs('[data-load-more-wrap]', doc);
        if (wrap) { if (newWrap) wrap.replaceWith(document.adoptNode(newWrap)); else wrap.remove(); }
        applyGridPreference(sectionEl);
      })
      .catch(function () { window.location.href = url; });
  });

  // Grid layout toggle
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-grid-cols]');
    if (!btn) return;
    var sectionEl = getFacetSection(btn) || document;
    var cols = btn.getAttribute('data-grid-cols');
    qsa('[data-product-grid]', sectionEl).forEach(function (grid) {
      grid.setAttribute('data-cols', cols === '2' ? '2' : (grid.className.match(/product-grid--(\d)/) || [0, '4'])[1]);
    });
    qsa('[data-grid-cols]', sectionEl).forEach(function (b) { b.classList.toggle('is-active', b === btn); });
    storageSet('veyro-grid-cols', cols === '2' ? '2' : '');
  });
  applyGridPreference(document);

  /* ==========================================================================
     Wishlist & recently viewed (stored in the shopper's browser)
     ========================================================================== */
  function readList(key) {
    try { var v = JSON.parse(storageGet(key) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function writeList(key, list) { storageSet(key, JSON.stringify(list)); }
  var WISHLIST_KEY = 'veyro-wishlist';
  var RECENT_KEY = 'veyro-recently-viewed';

  function syncWishlistUI() {
    var list = readList(WISHLIST_KEY);
    qsa('[data-wishlist-toggle]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-wishlist-toggle')) > -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    qsa('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      el.classList.toggle('is-empty', list.length === 0);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-wishlist-toggle');
    var list = readList(WISHLIST_KEY);
    var idx = list.indexOf(handle);
    if (idx > -1) { list.splice(idx, 1); toast('Removed from wishlist'); }
    else { list.unshift(handle); toast('Saved to wishlist'); btn.classList.add('is-popping'); setTimeout(function () { btn.classList.remove('is-popping'); }, 400); }
    writeList(WISHLIST_KEY, list.slice(0, 60));
    syncWishlistUI();
    var page = qs('[data-wishlist-page]');
    if (page && idx > -1) {
      var card = btn.closest('[data-product-card]');
      if (card) card.remove();
      if (!readList(WISHLIST_KEY).length) qs('[data-wishlist-empty]', page).hidden = false;
    }
  });

  function fetchCards(handles) {
    return Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '?section_id=product-card-render')
        .then(function (r) { if (!r.ok) throw new Error('gone'); return r.text(); })
        .then(function (html) {
          var wrap = qs('[data-card-render]', parseHTML(html));
          return wrap && wrap.firstElementChild ? { handle: h, el: document.adoptNode(wrap.firstElementChild) } : null;
        })
        .catch(function () { return { handle: h, el: null, missing: true }; });
    }));
  }

  var wishlistPage = qs('[data-wishlist-page]');
  if (wishlistPage) {
    var wlGrid = qs('[data-wishlist-grid]', wishlistPage);
    var wlEmpty = qs('[data-wishlist-empty]', wishlistPage);
    var saved = readList(WISHLIST_KEY);
    if (!saved.length) { wlEmpty.hidden = false; }
    else {
      fetchCards(saved).then(function (results) {
        var keep = [];
        results.forEach(function (r) {
          if (r && r.el) { wlGrid.appendChild(r.el); keep.push(r.handle); }
        });
        writeList(WISHLIST_KEY, keep); // drop products that no longer exist
        if (!keep.length) wlEmpty.hidden = false;
        syncWishlistUI();
      });
    }
  }

  // Track product views
  var productPage = qs('[data-product-root][data-product-handle]');
  if (productPage) {
    var handleNow = productPage.getAttribute('data-product-handle');
    var recent = readList(RECENT_KEY).filter(function (h) { return h !== handleNow; });
    recent.unshift(handleNow);
    writeList(RECENT_KEY, recent.slice(0, 12));
  }
  qsa('[data-recently-viewed]').forEach(function (sectionEl) {
    var current = sectionEl.getAttribute('data-current');
    var limit = parseInt(sectionEl.getAttribute('data-limit'), 10) || 4;
    var handles = readList(RECENT_KEY).filter(function (h) { return h && h !== current; }).slice(0, limit);
    if (!handles.length) return;
    fetchCards(handles).then(function (results) {
      var grid = qs('[data-recently-viewed-grid]', sectionEl);
      var count = 0;
      results.forEach(function (r) { if (r && r.el) { grid.appendChild(r.el); count++; } });
      if (count) { sectionEl.hidden = false; syncWishlistUI(); }
    });
  });

  syncWishlistUI();
  if ('MutationObserver' in window) {
    new MutationObserver(debounce(syncWishlistUI, 120)).observe(document.body, { childList: true, subtree: true });
  }

  /* ==========================================================================
     Drop countdown
     ========================================================================== */
  qsa('[data-countdown]').forEach(function (el) {
    var raw = el.getAttribute('data-countdown');
    var parts = raw.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{1,2}):(\d{2})/);
    if (!parts) return;
    var target = new Date(+parts[1], +parts[2] - 1, +parts[3], +parts[4], +parts[5], 0).getTime();
    var live = qs('[data-countdown-live]', el), ended = qs('[data-countdown-ended]', el);
    var hideWhenEnded = el.getAttribute('data-hide-when-ended') === 'true';
    var nums = { d: qs('[data-cd-days]', el), h: qs('[data-cd-hours]', el), m: qs('[data-cd-minutes]', el), s: qs('[data-cd-seconds]', el) };
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var timer;
    function tick() {
      var diff = Math.max(0, target - Date.now());
      if (diff <= 0) {
        clearInterval(timer);
        if (hideWhenEnded && !(window.Shopify && window.Shopify.designMode)) { el.hidden = true; return; }
        if (live) live.hidden = true;
        if (ended) ended.hidden = false;
        return;
      }
      var sec = Math.floor(diff / 1000);
      nums.d.textContent = pad(Math.floor(sec / 86400));
      nums.h.textContent = pad(Math.floor(sec % 86400 / 3600));
      nums.m.textContent = pad(Math.floor(sec % 3600 / 60));
      nums.s.textContent = pad(sec % 60);
    }
    tick();
    timer = setInterval(tick, 1000);
  });

  /* ==========================================================================
     Misc
     ========================================================================== */
  // Address forms: preselect country
  qsa('select[data-default]').forEach(function (select) {
    var val = select.getAttribute('data-default');
    if (!val) return;
    qsa('option', select).forEach(function (opt) { if (opt.value === val || opt.textContent === val) opt.selected = true; });
  });

  // Footer accordions: closed by default on mobile
  if (!isDesktop()) {
    qsa('.site-footer__accordion').forEach(function (d) { d.removeAttribute('open'); });
  }

  // Theme editor support
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      qsa('[data-product-root]', e.target).forEach(initProduct);
      initReveal(e.target);
      qsa('[data-reveal]', e.target).forEach(function (el) { el.classList.add('is-revealed'); });
    });
    qsa('[data-reveal]').forEach(function (el) { el.classList.add('is-revealed'); });
  }
})();
